export function contains(rect: number[], x: number, y: number): boolean {
  const isHit =
    x > rect[0] &&
    y > rect[1] &&
    x < rect[0] + rect[2] &&
    y < rect[1] + rect[3];
  return isHit;
}
